<template>
  <div class="dialog-wrap">
    <el-dialog
      title="页面编辑"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="90px">
        <el-form-item label="页面名称:" prop="name">
          <el-input v-model="dataForm.name" placeholder="输入页面名称"></el-input>
        </el-form-item>
        <el-form-item label="页面描述:" prop="description">
          <el-input
            type="textarea"
            v-model="dataForm.description"
            placeholder="输入页面描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pageList, pageOne, pageCreate, pageUpdate, pageDestroy } from '@/api/page'

export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        name: [{ required: true, message: '请输入页面名称', trigger: 'blur' }],
        description: { required: true, message: "请输入页面描述", trigger: "blur" },
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    content (val) {
      this.dataForm = val
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = {
            id: this.dataForm.id,
            name: this.dataForm.name,
            description: this.dataForm.description,
            sort: this.dataForm.sort,
            status: this.dataForm.status ? 1 : 0
          }
          pageUpdate(params).then(res => {
            this.$message.success(`更新成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;
    }
  }
</style>
